import { Injectable } from '@angular/core';
import { HttpClientService } from '@core/services/http-client/http-client.service';
import { API_URL_CONSTANT } from '@sharedModule/constants/api-url.constant';
import { DataGrid } from '@sharedModule/models/data-grid.model';
import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { removeEmptyStrings } from '@sharedModule/utils/form.utils';
import { Observable } from 'rxjs';
import { RoleListInterface } from '../../roles/types/role-list';
import { AddUserInterface, UpdateUserInterface } from '../types/upsert-user';
import { UserListInterface } from '../types/user-list';
import {
  UserListFilter,
  defaultUserListFilter,
} from '../types/user-list-filter';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private httpClient: HttpClientService) {}

  getUserList(
    payload: UserListFilter = defaultUserListFilter
  ): Observable<ResponseIdentity<DataGrid<UserListInterface[]>>> {
    return this.httpClient.post(
      API_URL_CONSTANT.user.getUserList,
      removeEmptyStrings(payload)
    );
  }

  getUserDetails(payload: {
    user_id: string;
    partner_id?: number;
  }): Observable<ResponseIdentity<UserListInterface>> {
    return this.httpClient.post(API_URL_CONSTANT.user.getUserDetails, payload);
  }

  addUser(payload: AddUserInterface): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(API_URL_CONSTANT.user.addUser, payload);
  }

  updateUser(payload: UpdateUserInterface): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(API_URL_CONSTANT.user.updateUser, payload);
  }

  getRoleListDropdown(payload: {
    role_type: string;
  }): Observable<ResponseIdentity<RoleListInterface[]>> {
    return this.httpClient.post(API_URL_CONSTANT.role.getRoleList, payload);
  }

  getPartnerRole(): Observable<ResponseIdentity<RoleListInterface[]>> {
    return this.httpClient.post(API_URL_CONSTANT.user.getPartnerRole, {});
  }

  deleteUser(payload: {
    user_id: string;
    partner_id: number;
  }): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(API_URL_CONSTANT.user.deleteUser, payload);
  }
}
